import warning from 'warning';

function isRaygunAvailable() {
    return typeof window !== 'undefined' ? window.rg4js : false;
}

function agent(...args) {
    const raygun = isRaygunAvailable();
    if (raygun) {
        const RIC = window.requestIdleCallback;

        if (RIC) {
            // not going use timeout as monitoring is not as important as our code
            RIC(() => wrapper(...args));
        } else {
            wrapper(...args);
        }
    } else {
        warning(false, 'Raygun is undefined');
        warning(...args, 'Arguments could not be run');
    }
    // little helper function make testing easier
    function wrapper(...args) {
        raygun(...args);
    }
}

export { isRaygunAvailable, agent };
